import { render, staticRenderFns } from "./confirm-reset.vue?vue&type=template&id=2588e696&scoped=true&"
import script from "./confirm-reset.vue?vue&type=script&lang=js&"
export * from "./confirm-reset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2588e696",
  null
  
)

export default component.exports